// tslint:disable: max-line-length

import { BENEFICIARIES, DATA_UPDATE, FUND_CHANGE_URL, HOME_URL, ONBOARDING, PROFILE, TRANSACTIONS, URL_ESTIMADOR_PENSION, VIDEO_ATENCION } from "./url.constant";

// tslint:disable: object-literal-key-quotes
export const MIN_DESKTOP_WIDTH = 839;

export const NUMBER_REGEX = new RegExp(/^\d*$/);

export const ALPHANUMERIC_REGEX = new RegExp(/^[a-zA-Z0-9]*$/);

export const PHONE_PATTERN = new RegExp(/^(\+56)?(\s?)(0?9)(\s?)[9876543]\d{7}$/);

export const EMAIL_PATTERN = new RegExp(/^[\w.-]+@[\w.-]+\.[a-z]{2,}$/);

export const ALLOWED_4_LENGTH_PASSWORD_VALIDATION = {
  min: 4,
  max: 4
};

export const ALLOWED_LENGTH_OLD_PASSWORD_VALIDATION = {
  min: 4,
  max: 6
};

export const ALLOWED_4_LENGTH_OLD_PASSWORD_VALIDATION = {
  min: 4,
  max: 4
};
export const ALLOWED_6_LENGTH_OLD_PASSWORD_VALIDATION = {
  min: 6,
  max: 6
};

export const ALLOWED_LENGTH_NEW_PASSWORD_VALIDATION = {
  min: 4,
  max: 6
};
export const ALLOWED_6_LENGTH_NEW_PASSWORD_VALIDATION = {
  min: 6,
  max: 6
};

export const ALLOWED_LENGTH_RUT_VALIDATION = {
  min: 2,
  max: 12
};

export const ALLOWED_LENGTH_SECURITY_KEY_VALIDATION = {
  min: 6,
  max: 10
};

export const ALLOWED_LENGTH_DYNAMIC_KEY_VALIDATION = {
  min: 1,
  max: 1
};

export const ALLOWED_LENGTH_DYNAMIC_PASSWORD_VALIDATION = {
  min: 6,
  max: 6
};

export const ALLOWED_LENGTH_EMAIL_VALIDATION = {
  min: 8,
  max: 40
};

export const ALLOWED_LENGTH_CELLPHONE_VALIDATION = {
  min: 8,
  max: 12
};

export const CALL_CENTER_NUMBER = 'tel:23 293 4655';

export const FORGET_PASSWORD_URL = 'https://www.afpcapital.cl/Paginas/Obtener-Clave.aspx';

export const FORGET_SECURITY_KEY_URL = 'https://www.afpcapital.cl/Ayuda/Paginas/Clave-de-seguridad.aspx';

export const PRIVATE_SITE_URL = 'https://www.afpcapital.cl/Paginas/default.aspx?IDList=1';

export const BRANCH_OFFICE_URL = 'https://www.afpcapital.cl/paginas/nuestras_sucursales.aspx';

export const HOME_AFP_URL = 'https://www.afpcapital.cl/Paginas/default.aspx';

export const WHATSAPP_URL = 'https://api.whatsapp.com/send?phone=56936391222';

export const TITLE_MODAL_CHANGE_FUND_INFORMATION = 'Información importante';
export const BUTTON_URL_CHANGE_FUND_INFORMATION = 'https://www.spensiones.cl/portal/compendio/596/w3-propertyvalue-3623.html';
export const BUTTON_CHANGE_FUND_INFORMATION = 'Compendio de Normas, Administración de Cuentas Personales, Cambio y Asignación de Fondos, No53.';
export const DESCRIPTION_MODAL_CHANGE_FUND_INFORMATION = 'El cambio y distribución de tus Fondos se realizará en 4 días hábiles desde la fecha de la solicitud.<br>Si se registran volúmenes inusuales de solicitudes de cambio y distribución de fondos, este plazo podría extenderse por más de lo habitual.La materialización de tu cambio de fondo debe producirse al 4o día hábil posterior a la fecha de la solicitud.<br><br>Sin embargo, en ocasiones que se registren volúmenes inusuales de solicitudes de cambio o distribución de fondos, este plazo podría extenderse por más de lo habitual. Esto, dado que la normativa vigente establece que la Administradora deberá materializar las operaciones de cambio de fondos traspasando diariamente solo hasta el 5% del valor del respectivo patrimonio, traspasando en primer lugar los cambios de fondos más antiguos y así sucesivamente hasta completar el total de cambios suscritos en los días siguientes.<br><br>Para mayor información, puedes visitar el siguiente enlace donde se estipula lo antes señalado:<br>';
export const MOMENTARY_TRANSACTION_DURATION_MINUTES = 20;
export const DEFAULT_SERVICE_TIMEOUT = 30000;
export const RESTRUCTURE_FUNDS_SERVICE_TIMEOUT = 15000;

export const BAD_REQUEST_HTTP_STATUS_CODE = 400;


export const PASSWORD_TYPE = {
  fourDigits: 'fourDigits',
  sixDigits: 'sixDigits',
  provisional: 'provisional',
  new: 'new',
  confirmed: 'confirmed',
  securityKey: 'securityKey',
  dynamic: 'dynamic'
};

export const MAX_ATEMPTS_SECURITY_KEY = 3;
export const MAX_ATEMPTS_DYNAMIC_PASSWORD = 3;
export const SECURITY_AND_DYNAMIC_PASSOWORD_BUSSINESS_CODE = [400004,400016,400003,400014,400013];

export const API_SANTANDER_ERROR_MODAL = {
  id: 'errorApiSantander',
  title: 'Lo sentimos, no fue posible validar la existencia de la cuenta',
  checkText: 'Declaro que quiero utilizar esta cuenta aunque no se haya validado su existencia, ya sea por ingresar mal un dato o que la cuenta es reciente (menor a 6 meses)',
  primaryButtonText: 'Ver mis cuentas',
  secondaryButtonText: 'Agregar cuenta',
  logo: 'assets/icons/error-dark.svg'
}

export const BANK_ACCOUNTS_ERROR_MODAL = {
  id: 'errorBankAccounts',
  title: 'Lo sentimos, ocurrió un error al cargar la información',
  primaryButtonText: 'Elegir depósito',
  secondaryButtonText: 'Agregar una cuenta',
  logo: 'assets/icons/error-dark.svg',
};

export const DIGITAL_ACCOUNT_ERROR_MODAL = {
  id: 'errorCtaDigital',
  title: 'Lo sentimos, no podemos agregar cuentas digitales',
  subtitle: 'Por seguridad, no es posible girar hacia cuentas digitales como Mach, Superdigital, Check, Tenpo, FAN, entre otras',
  primaryButtonText: 'Ver mis cuentas',
  secondaryButtonText: 'Agregar cuenta',
  logo: 'assets/icons/error-dark.svg'
}

export const EXIT_MODAL_CAMBIO_VIA_PAGO = {
  id: 'exit',
  title: '¿Quieres salir de la solicitud de cambio de vía de pago de pensión?',
  primaryButtonText: 'Salir',
  secondaryButtonText: 'Continuar solicitud',
  logo: 'assets/icons/error-dark.svg',
};

export const EXIT_MODAL_CONGELAMIENTO_SALDOS = {
  id: 'exit',
  title: '¿Quieres salir de la solicitud de Congelamiento de saldos?',
  primaryButtonText: 'Salir',
  secondaryButtonText: 'Continuar en solicitud',
  logo: 'assets/icons/error-dark.svg',
};

export const EXIT_MODAL_DATOS_PERSONALES = {
  id: 'exit',
  title: 'Para actualizar tu información te llevaremos a "Tus datos"',
  primaryButtonText: 'Ir a Tus datos',
  secondaryButtonText: 'Continuar solicitud',
  logo: 'assets/icons/error-dark.svg',
};

export enum PaymentDestiny {
  Agencia = 'AG',
  Correo = 'CO',
  ValeVista = 'VV',
  CuentaAhorro = 'CA',
  CuentaCorriente = 'CC',
  CuentaRut = 'CR',
  CuentaVista = 'CV',
}

export const PaymentAVProps = {
  accountTypeCode: PaymentDestiny.ValeVista,
  accountTypeDescription: 'Vale Vista',
  bankCode: '37',
  bankName: 'Banco Santander',
  bankNumberAccount: '000000000000000000',
  paymentType: 'Vale vista'
};

export const ACCOUNTS_BALANCE_FREEZING = 'accounts_balance_freezing';


export enum TipoMensajeSalidaFlujoTramitePension {
  VideoAtencion = 'VideoAtencion',
  ActualizaDatos = 'ActualizaDatos',
  CambioFondo = 'CambioFondo',
  Beneficiario = 'Beneficiario',
  Estimador = 'Estimador'
}

export const MensajeSalidaFlujoTramitePension: Record<TipoMensajeSalidaFlujoTramitePension, {
  id: string;
  title: string;
  subtitle: string;
  primaryButtonText: string;
  secondaryButtonText: string;
  url: string;
  urlDestino?: string;
}> = {
  [TipoMensajeSalidaFlujoTramitePension.VideoAtencion]: {
    id: TipoMensajeSalidaFlujoTramitePension.VideoAtencion,
    title: 'Agenda una Video Atención',
    subtitle: 'Te llevaremos a "Agendar Video Atención" para que un ejecutivo te ayude con tus consultas.',
    primaryButtonText: 'Ir a Video Atención',
    secondaryButtonText: 'Continuar trámite',
    url: 'assets/icons/error-dark.svg',
    urlDestino: `/${VIDEO_ATENCION}`
  },
  [TipoMensajeSalidaFlujoTramitePension.ActualizaDatos]: {
    id: TipoMensajeSalidaFlujoTramitePension.ActualizaDatos,
    title: 'Actualiza tus datos',
    subtitle: 'Te llevaremos a "Tus Datos" para que edites tu información.',
    primaryButtonText: 'Ir a Tus Datos',
    secondaryButtonText: 'Continuar trámite',
    url: 'assets/icons/error-dark.svg',
    urlDestino: `/${DATA_UPDATE}/${HOME_URL}/${PROFILE}`
  },
  [TipoMensajeSalidaFlujoTramitePension.CambioFondo]: {
    id: TipoMensajeSalidaFlujoTramitePension.CambioFondo,
    title: 'Cambio de Fondo',
    subtitle: 'Te llevaremos a "Cambio de Fondo" para que hacerlo.',
    primaryButtonText: 'Ir a Cambio de Fondo',
    secondaryButtonText: 'Continuar trámite',
    url: 'assets/icons/error-dark.svg',
    urlDestino: `/${TRANSACTIONS}/${FUND_CHANGE_URL}/${ONBOARDING}`
  },
  [TipoMensajeSalidaFlujoTramitePension.Beneficiario]: {
    id: TipoMensajeSalidaFlujoTramitePension.Beneficiario,
    title: 'Agrega o modifica tus beneficiarios',
    subtitle: 'Te llevaremos a "Personas beneficiarias" para que puedas realizar la modificación.',
    primaryButtonText: 'Ir a Beneficiarios',
    secondaryButtonText: 'Continuar trámite',
    url: '',
    urlDestino: `/${DATA_UPDATE}/${BENEFICIARIES}/${HOME_URL}`
  },
   [TipoMensajeSalidaFlujoTramitePension.Estimador]: {
    id: TipoMensajeSalidaFlujoTramitePension.Estimador,
    title: 'Estimador de pensiones',
    subtitle: 'Te llevaremos al "Estimador de pensiones” para saber cuánto impactará el monto que traspases a tu pensión.',
    primaryButtonText: 'Ir al Estimador',
    secondaryButtonText: 'Continuar trámite',
    url: '',
    urlDestino: `/${URL_ESTIMADOR_PENSION}`
  }
};